import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-no-access',
    imports: [],
    templateUrl: './no-access.component.html',
    styleUrl: './no-access.component.scss'
})
export class NoAccessComponent implements OnInit {
  accessRequestUrl : string;
  mailDL :string ;

    ngOnInit() {
        this.accessRequestUrl = environment.accessRequestUrl;
        this.mailDL =environment.mailDl
    }

}
